import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

import { StyledPortionNumberInput } from './PortionNumberInput.styled';
import { StyledTimeOfDayIcon } from './TimeOfDayIcon.styled';

const DIMMED_ICON_OPACITY = 0.2;

type DimmableProps = {
   readonly dimmed: boolean;
};

export const StyledTimeOfDayPortionField = styled.div<DimmableProps>`
   ${basicBodyTextStyle};

   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 4px;
   color: ${({ dimmed, theme }) => (dimmed ? theme.backgroundDark : 'inherit')};

   ${StyledPortionNumberInput} {
      width: 80px;
   }

   ${StyledTimeOfDayIcon} {
      opacity: ${({ dimmed }) => (dimmed ? DIMMED_ICON_OPACITY : 1)};
   }
`;

StyledTimeOfDayPortionField.displayName = 'StyledTimeOfDayPortionField';

export const StyledTimeOfDayLabel = styled.span<DimmableProps>`
   color: ${({ dimmed, theme }) => (dimmed ? theme.backgroundDark : theme.textBody)};
`;

StyledTimeOfDayLabel.displayName = 'StyledTimeOfDayLabel';
